import { useShallow } from 'zustand/react/shallow';
import { useTenantStore } from '@/hooks/data/tenant/useTenantStore';
import Head from 'next/head';

export const useGeneratePageTitle = () => {
  const { tenant } = useTenantStore(useShallow((s) => ({ tenant: s.tenantData?.tenant })));

  const generatePageTitle = (parts: Array<string> = ['Home']) => {
    const allParts = [...parts.filter(Boolean), tenant?.name ?? 'Great Bowery', 'DAM'].filter(Boolean);
    const title = allParts.join(' | ');
    return (
      <Head>
        <title>{title}</title>
      </Head>
    );
  };

  return {
    generatePageTitle,
  };
};
